module.exports = __webpack_public_path__ + "static/media/sumit_resume.c95adab6.docx";